import React, {Component} from "react";
import "../../VisitHistory.css"
import {buildGaitGrid} from "../../../assessment/utils/GaitAnalysisUtil";

export default class gaitAnalysisView extends Component {


    render() {
        if (this.checkGaitAnalysisEmpty(this.props.gaitAnalysis) ||
            this.props.gaitAnalysis.none) {
            return <div className="pl-3">
                {this.props.gaitAnalysis && this.props.gaitAnalysis.none ? "Normal" : "No information available"}
            </div>;
        }
        const items = buildGaitGrid(this.props.gaitAnalysis.items);

        return (
            <table className={"visit-history-table"}>
                <tbody>
                <tr style={{backgroundColor: "rgba(197, 224, 181, 0.4)"}}>
                    <th></th>
                    <th>Heel Strike</th>
                    <th>Foot Flat</th>
                    <th>Mid Stance</th>
                    <th>Heel Off</th>
                    <th>Toe Off</th>
                    <th>Early Swing</th>
                    <th>Mid Swing</th>
                    <th>Late Swing</th>

                </tr>
                <tr>
                    <td className={"gaitAnalysisRowHeader"}>
                        Upper Back & Shoulders
                    </td>
                    <td>
                        {items[32].details}
                    </td>
                    <td>
                        {items[33].details}
                    </td>
                    <td>
                        {items[34].details}
                    </td>
                    <td>
                        {items[35].details}
                    </td>
                    <td>
                        {items[36].details}
                    </td>
                    <td>
                        {items[37].details}
                    </td>
                    <td>
                        {items[38].details}
                    </td>
                    <td>
                        {items[39].details}
                    </td>

                </tr>
                <tr>
                    <td className={"gaitAnalysisRowHeader"}> Arms</td>
                    <td>
                        {items[24].details}
                    </td>
                    <td>
                        {items[25].details}
                    </td>
                    <td>
                        {items[26].details}
                    </td>
                    <td>
                        {items[27].details}
                    </td>
                    <td>
                        {items[28].details}
                    </td>
                    <td>
                        {items[29].details}
                    </td>
                    <td>
                        {items[30].details}
                    </td>
                    <td>
                        {items[31].details}
                    </td>
                </tr>
                <tr>
                    <td className={"gaitAnalysisRowHeader"}> Pelvis & Hips</td>
                    <td>
                        {items[16].details}
                    </td>
                    <td>
                        {items[17].details}
                    </td>
                    <td>
                        {items[18].details}
                    </td>
                    <td>
                        {items[19].details}
                    </td>
                    <td>
                        {items[20].details}
                    </td>
                    <td>
                        {items[21].details}
                    </td>
                    <td>
                        {items[22].details}
                    </td>
                    <td>
                        {items[23].details}
                    </td>
                </tr>
                <tr>
                    <td className={"gaitAnalysisRowHeader"}>Knee</td>
                    <td>
                        {items[8].details}
                    </td>
                    <td>
                        {items[9].details}
                    </td>
                    <td>
                        {items[10].details}
                    </td>
                    <td>
                        {items[11].details}
                    </td>
                    <td>
                        {items[12].details}
                    </td>
                    <td>
                        {items[13].details}
                    </td>
                    <td>
                        {items[14].details}
                    </td>
                    <td>
                        {items[15].details}
                    </td>
                </tr>
                <tr>
                    <td className={"gaitAnalysisRowHeader"}> Ankle</td>
                    <td>
                        {items[0].details}
                    </td>
                    <td>
                        {items[1].details}
                    </td>
                    <td>
                        {items[2].details}
                    </td>
                    <td>
                        {items[3].details}
                    </td>
                    <td>
                        {items[4].details}
                    </td>
                    <td>
                        {items[5].details}
                    </td>
                    <td>
                        {items[6].details}
                    </td>
                    <td>
                        {items[7].details}
                    </td>
                </tr>
                </tbody>
            </table>
        );
    }

    checkGaitAnalysisEmpty = (gaitAnalysis) => {
        if (gaitAnalysis != null && gaitAnalysis.items != null && gaitAnalysis.items.length != 0) {
            for (const item of gaitAnalysis.items) {
                if (item.details != "") {
                    return false;
                }
            }
        }
        return true;
    }
}